import { useNls } from '../../nls/nlsProvider'
import type { ResourceSignal, ResourceSignalSeverity } from '../../types/resource'
import { ChipGroup, type ChipGroupItem, StatusChip, type StatusPillTone } from '../Common'
import { getResourceSignalLabel } from './ResourcesNls'
import './resources.css'

type Props = {
  signals: ResourceSignal[]
  compact?: boolean
}

const SEVERITY_TONES: Record<ResourceSignalSeverity, StatusPillTone> = {
  clear: 'success',
  warning: 'warning',
  blocked: 'danger',
}

export const ResourceBadges = ({ signals, compact = false }: Props) => {
  const { t } = useNls()
  const visible = signals.filter((signal) => signal.severity !== 'clear')
  if (visible.length === 0) return null

  const items: ChipGroupItem[] = visible.map((signal) => {
    const label = getResourceSignalLabel(signal.kind, t)
    return {
      id: `${signal.kind}-${signal.label}-${signal.summary}`,
      label,
      node: (
        <span title={signal.detail ?? signal.summary}>
          <StatusChip
            tone={SEVERITY_TONES[signal.severity]}
            size={compact ? 'sm' : 'md'}
            className={`resourceBadge is-${signal.severity} is-${signal.kind}`}
          >
            {label}
          </StatusChip>
        </span>
      ),
    }
  })

  return (
    <ChipGroup
      layout="wrap"
      ariaLabel={t('NLSResourcesSignalsAria')}
      className={`resourceBadges${compact ? ' resourceBadges--compact' : ''}`}
      items={items}
      size={compact ? 'sm' : 'md'}
    />
  )
}
